'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlHasQueryParam = getUrlHasQueryParam;
exports.getUsageTrackingParam = getUsageTrackingParam;
function getUrlHasQueryParam(url) {
  return (/\?/.test(url)
  );
}

function getUsageTrackingParam(url) {
  return (getUrlHasQueryParam(url) ? '&' : '?') + 'utm_source=sprocket-menu';
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/url.js
// module id = 6
// module chunks = 0 1